import { useState } from "react";
import { api } from "../../../../../../utility/api";
import { descargarReporteExcel } from "../../helpers/descargarReporteExcel";

const ENDPOINT = "cierres_mensuales_produccion";

export const CierresMensualesProduccionApi = () => {
    const [cargando, setCargando] = useState(false);

    // qué abarcaría un cierre con esa fecha de corte y qué falta para poder
    // registrarlo
    const getPrevisualizacion = async (params) => {
        try {
            setCargando(true);
            return await api.get(`${ENDPOINT}/previsualizacion`, params);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const registrarCierre = async (data) => {
        try {
            setCargando(true);
            return await api.post(ENDPOINT, data);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // diferencia acopio de los periodos que el producto padre compartió con
    // otros, antes de registrar el cierre
    const guardarDiferenciasAcopio = async (data) => {
        try {
            setCargando(true);
            return await api.post(
                `${ENDPOINT}/guardar_diferencias_acopio`,
                data,
            );
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getCierres = async (params) => {
        try {
            setCargando(true);
            return await api.get(ENDPOINT, params);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const getCierre = async (id) => {
        try {
            setCargando(true);
            return await api.get(`${ENDPOINT}/${id}`);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // el comparativo que quedó registrado en el cierre, junto con los reportes
    // de los que salieron sus cifras
    const getComparativoDelCierre = async (id) => {
        try {
            setCargando(true);
            return await api.get(`${ENDPOINT}/${id}/comparativo`);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // el mismo comparativo del cierre, en el formato del archivo del cliente
    const descargarComparativoDelCierreExcel = async (id) => {
        try {
            setCargando(true);
            await descargarReporteExcel(
                `${ENDPOINT}/${id}/comparativo_excel`,
                {},
                "cierre_mensual_produccion.xlsx",
            );
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    const eliminarCierre = async (id) => {
        try {
            setCargando(true);
            return await api.eliminar(`${ENDPOINT}/${id}`);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    // si al producto padre le toca su primer cierre y desde dónde puede arrancar
    const getSiguienteCierre = async (params) => {
        try {
            setCargando(true);
            return await api.get(`${ENDPOINT}/siguiente_cierre`, params);
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getPrevisualizacion,
        getSiguienteCierre,
        registrarCierre,
        guardarDiferenciasAcopio,
        getCierres,
        getCierre,
        getComparativoDelCierre,
        descargarComparativoDelCierreExcel,
        eliminarCierre,

        cargando,
    };
};
